import {
  Box,
  Button,
  Menu,
  MenuItem,
  Tab,
  TableCell,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { styles } from "./style";
import dropDownIcon from "../../../../../../assets/AccountingModule/dropdown_black.svg";
import deleteIcon from "../../../../../../assets/AccountingModule/delete.svg";
import { useAlert } from "../../../../../../context/AlertContext";
import FulfillmentTypeModal from "../../../../../../modals/FulfillmentTypeModal/FulfillmentTypeModal";
import PartialFulfillmentModal from "../../../../../../modals/PartialFulfillmentModal";
import color from "../../../../../../constants/color";
import { formatDate } from "../../../../../../utils/DateFormat";
const ViewSalesOrderPage = ({
  handleShowPdf,
  handleDownloadReceipt,
  getEditNotesData,
  handleSendSalesOrder,
  deleteCreditApply,
  handleFulfillmentComplete,
  salesOrderData,
  updatePartialFullfillment,
  itemList,
  refreshData,
}) => {
  const [billHtml, setBillHtml] = useState("");
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [fulfillmentModalOpen, setFulfillmentModalOpen] = useState(false);
  const [partialModalOpen, setPartialModalOpen] = useState(false);
  const { item } = useLocation().state || {};
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchShowPdfHtml = async () => {
      const result = await handleShowPdf();
      setBillHtml(result.__html);
    };
    fetchShowPdfHtml();
  }, [handleShowPdf]);

  useEffect(() => {
    if (item?._id) {
      getEditNotesData(item._id);
    }
  }, []);

  const handleOpenPurchaseModal = () => {
    showAlert("Development in Progress", "success");
  };

  const handleOpenModal = () => {
    setFulfillmentModalOpen(true);
  };

  const handleCloseModal = () => {
    setFulfillmentModalOpen(false);
  };

  const handleFulfillmentSelect = (type) => {
    if (type === "complete") {
      handleFulfillmentComplete(item?._id);
    } else if (type === "partial") {
      setPartialModalOpen(true);
    }
  };

  const handlePartialModalClose = () => {
    setPartialModalOpen(false);
  };

  const handlePartialFulfillmentSubmit = (fulfillmentData) => {
    updatePartialFullfillment(item?._id, fulfillmentData);
    handlePartialModalClose();
  };

  const hadleNavigateInvoice = () => {
    navigate("/dashboard/salesHome/createNewInvoice", {
      state: {
        item: salesOrderData,
        itemList,
      },
    });
  };

  return (
    <>
      <Box sx={{ ml: 2, display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="success"
            sx={styles.csvBtns}
            onClick={handleDownloadReceipt}
          >
            {"Download"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={{ ...styles.checkinBtns, borderLeft: "1px solid #fff" }}
            onClick={handleSendSalesOrder}
          >
            {"Send Sales Order"}
          </Button>

          <Button
            variant="contained"
            color="success"
            sx={{ ...styles.checkinBtns, borderLeft: "1px solid #fff" }}
            onClick={hadleNavigateInvoice}
          >
            {"Convert to Invoice"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={{ ...styles.checkinBtns, borderLeft: "1px solid #fff" }}
            onClick={handleOpenModal}
          >
            {"Mark shipment as fulfilled"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={{ ...styles.checkinRefundBtns, borderLeft: "1px solid #fff" }}
            onClick={handleOpenPurchaseModal}
          >
            {"Convert to Purchase Order"}
          </Button>
        </Box>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Box sx={styles.paymentSection}>
          <Box sx={styles.paymentHeader}>
            <Box sx={styles.paymentTitleContainer}>
              <Typography sx={styles.paymentTitle}>Invoices</Typography>
              <Typography sx={styles.paymentCount}>
                {salesOrderData?.invoice?.length}
              </Typography>
            </Box>
            <Box>
              <button
                type="button"
                style={styles.dropDownButton}
                aria-label="Open payment options"
                onClick={() => setIsTableVisible((prev) => !prev)}
              >
                <img
                  src={dropDownIcon}
                  alt="Dropdown Icon"
                  style={{
                    transform: isTableVisible
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </button>
            </Box>
          </Box>
          {isTableVisible && (
            <Box sx={{ overflowX: "auto" }}>
              <table>
                <thead
                  style={{
                    background: "transparent !important",
                    borderBottom: "1px solid #D9D9D9",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        ...styles.tableHeader,
                        backgroundColor: "transparent",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        ...styles.tableHeader,
                        backgroundColor: "transparent",
                      }}
                    >
                      Invoice Number
                    </th>
                    <th
                      style={{
                        ...styles.tableHeader,
                        backgroundColor: "transparent",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        ...styles.tableHeader,
                        backgroundColor: "transparent",
                      }}
                    >
                      Amount Due
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {salesOrderData?.invoice?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Typography variant="h6">No data</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    salesOrderData?.invoice?.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{ ...styles.tableCell, borderBottom: "none" }}
                        >
                          {item?.invoiceDate
                            ? formatDate(item.invoiceDate)
                            : "N/A"}
                        </td>
                        <td
                          style={{
                            ...styles.tableCell,
                            borderBottom: "none",
                            color: color.secondary,
                          }}
                        >
                          <Box
                            onClick={() =>
                              navigate("/dashboard/viewInvoice", {
                                state: { item: { _id: item.invoiceId } },
                              })
                            }
                          >
                            {item?.invoiceNo || "N/A"}
                          </Box>
                        </td>
                        <td
                          style={{ ...styles.tableCell, borderBottom: "none" }}
                        >
                          {item?.status || "N/A"}
                        </td>
                        <td
                          style={{ ...styles.tableCell, borderBottom: "none" }}
                        >
                          {item?.amountDue ?? "N/A"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={styles.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>
      <FulfillmentTypeModal
        open={fulfillmentModalOpen}
        onClose={handleCloseModal}
        onSelect={handleFulfillmentSelect}
      />
      <PartialFulfillmentModal
        open={partialModalOpen}
        onClose={handlePartialModalClose}
        data={salesOrderData}
        updatePartialFullfillment={handlePartialFulfillmentSubmit}
      />
    </>
  );
};

export default ViewSalesOrderPage;
